<div v-if="contractId">
  <ContractBodyComponent :contractDetails="contractDetails" />
  <ContractActionsComponent :contractDetails="contractDetails" :currentPartner="currentPartner"
    @click:action="onHandleAction($event)" />
  <OtpComponent ref="otp" :nationalId="currentUser.username" @verify="onOtpVerified" />
</div>